import tw, { css } from "twin.macro";

const sizes = {
  "12": tw`w-12 h-12`,
  "16": tw`w-16 h-16`,
  "20": tw`w-20 h-20`,
  "24": tw`w-24 h-24`,
  "32": tw`w-32 h-32`,
} as const;

export type IconComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;

/** @legacy Used for CMS-driven fields only. Prefer IconComponent for static usage. */
export type IconName =
  | "arrow-top-right"
  | "arrow-down"
  | "arrow-left"
  | "arrow-right"
  | "arrow-up"
  | "caret-down"
  | "caret-left"
  | "caret-right"
  | "caret-up"
  | "checkmark"
  | "close"
  | "copy"
  | "download"
  | "eye-off"
  | "eye-on"
  | "horizontal-resolution"
  | "info"
  | "instagram"
  | "language"
  | "link"
  | "linkedin"
  | "loading"
  | "location"
  | "menu"
  | "minus"
  | "pause"
  | "play"
  | "plus"
  | "precision"
  | "range"
  | "upload"
  | "vertical-resolution"
  | "warning"
  | "weight"
  | "x"
  | "youtube";

export type IconSize = keyof typeof sizes;

type Props = {
  icon: IconComponent;
  size?: IconSize;
  color?: string;
};

export function Icon(props: Props & React.ComponentPropsWithRef<"span">) {
  const { icon: Component, size = "16", color, ...rest } = props;

  if (!Component) {
    return null;
  }

  return (
    <span
      css={[
        css`
          ${tw`shrink-0 inline-flex items-center justify-center pointer-events-none`}

          ${color &&
          css`
            color: ${color};
          `}

          > svg {
            ${tw`w-full h-full`}
          }
        `,
        sizes[size],
      ]}
      {...rest}
    >
      <Component />
    </span>
  );
}
